import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
export var listingAvailability = /*#__PURE__*/css("display:flex;flex-direction:column;", media('>=desktop'), "{flex-direction:row;}");
export var heading = /*#__PURE__*/css(media('>=desktop'), "{width:200px;margin-bottom:0;}");
export var body = /*#__PURE__*/css(designTokenFonts.mini, " ", media('>=desktop'), "{", designTokenFonts.body, " overflow:hidden;max-width:440px;}");
export var date = /*#__PURE__*/css(designTokenFonts.bodyBold);